export const useMainStore = defineStore("main", () => {
    const sources = ref<Sources | undefined>(undefined)
    const tokens = ref<any>(undefined)

    const config = ref<any>(undefined)

    const appId = ref<string>("prazsky-ulicnik")

    const dataPU = ref<PuData[]>([])

    const isReady = ref<boolean>(false)

    const isFirstLoad = ref(true)

    const viewReady = ref<boolean>(false)
    const sourceReady = ref<boolean>(false)

    const souborneHesloReady = ref<boolean>(true)

    const showNoGeometryBanner = ref<boolean>(false)

    const resultAbecedniSeznamUlic = ref<boolean>(false)

    const modulePaths: Record<string, string> = {}
    const panelWidgets: Record<string, string> = {}

    const mobileMode = ref<boolean>(false)

    const mobileMapStreetOpen = ref<boolean>(true)
    const mobileDetailStreetOpen = ref<boolean>(false)

    const mobileMapSouborneHesloOpen = ref<boolean>(true)
    const mobileDetailSouborneHesloOpen = ref<boolean>(false)
    const mobileShowHideSouborneHesloButton = ref<boolean>(false)

    const showMobilePopupAlertResponsive = ref<boolean>(true)

    const isSwipeActive = ref<boolean>(false)

    const cookiesBannerActive = ref<boolean>(false)
    const cookiesSettingsModalActive = ref<boolean>(false)
    const cookiesPermissions = ref<Record<CookiesType, boolean>>({
        technical: false,
        analytical: false,
    })

    const activeBasemapId = ref<string>("MTVU_bw")
    const activeWidgetId = ref<string>("BasemapWidget")

    const activeHistoricmapId = ref<string>("")

    const suggestionsActive = ref<boolean>(true)

    const appHelpActive = ref<boolean>(false)

    const streetsAll = ref<Array<Record<string, any>>>([])

    const eventTargetValueHledat = ref("")
    const resultSuggestions = ref<Street[]>([])

    const apiBaseUrl = ref<string>("")
    const apiBaseUrlInt = ref<string>("")

    const visualizeData = ref<VisualizeData>({
        imgReady: false,
        imgInfo: null,
        fileInfo: null,
        nazevUlice: "",
        nazevSoubornehoHesla: "",
        obsahSoubornehoHesla: "",
        typHeslaUlice: "RÚIAN",
        kodUlice: "",
        katastr: "",
        puvodNazvu: "",
        prehistorie: "",
        vizTez: "",
        historickeNazvy: [],
        historickeNazvySegment: [],
        vazbaRuian: [],
        pramen: [],
        obrazek: [],
        dokument: [],
        osobnost: [],
        vazbaPlan: "",
        budova: [],
        odkazy: [],
    })

    const loadSources = async () => {
        try {
            // const baseUrl =
            //     window.location.href.includes("localhost") ||
            //     window.location.href.includes("appt")
            //         ? "https://appt.iprpraha.cz/apl-dev"
            //         : "https://app.iprpraha.cz/apl"

            const baseUrl = "https://appt.iprpraha.cz/apl-dev"
            const response = await fetch(baseUrl + "/_src/sources.json")



            const data = (await response.json()) as Sources
            sources.value = data
        } catch (error) {
            console.log(error)
        }
    }

    const loadTokens = async () => {
        const protocol =
            window.location.host === "http://localhost:3000/"
                ? "/"
                : window.location.host.split(".")[0]
        try {
            // const response = await fetch(
            //     "https://appt.iprpraha.cz/apl-dev/_src/newTokens_test.json"
            // )
            const response = await fetch(
                "https://geoportalpraha.cz/backend/get-tokens"
            )
            const data = (await response.json()) as AllTokens

            if (protocol && data[protocol]) {
                tokens.value = data[protocol] || null
            }
        } catch (error) {
            console.log(error)
        }
    }

    const loadConfig = async () => {
        try {
            const response = await fetch("./app_config.json")
            const data = await response.json()
            config.value = data

            console.log("Config loaded")
            console.log(config.value)
        } catch (error) {
            console.warn("Error fetching pages")
            console.warn(error)
        }
    }

    const getModulesFromConfig = () => {
        //let active = ""

        for (const item in config.value) {
            const id = item.substring(item.lastIndexOf("/") + 1)
            const path = item
            modulePaths[id] = path

            // const breakpoints = useBreakpoints(breakpointsTailwind)
            // const isMobile = breakpoints.smaller("md")
            // if (config[item].defaultActive && !isMobile.value) {
            //     active = id
            // }
        }
        //activeWidgetId.value = active
    }

    const getSourceUrl = (sourceId: string) => {
        if (!sources) {
            console.log("Sources ešte neboli načítané")
            return
        }
        return sources.value?.[sourceId]
    }

    const addPathToUrl = (url: string, path: string) => {
        // check if the URL has parameters
        let params = ""
        const paramsIdx = url.indexOf("?")

        if (paramsIdx > -1) {
            params = url.substring(paramsIdx) // parameters only
            url = url.substring(0, paramsIdx) // url without parameters
        }

        // check if the url ends with '/' or not
        if (url[url.length - 1] !== "/") {
            url += "/" // if slash is missing, add it into the URL
        }

        return url + path + params
    }

    return {
        sources,
        tokens,
        config,

        appId,
        dataPU,
        isReady,
        isFirstLoad,

        viewReady,
        sourceReady,
        souborneHesloReady,

        showNoGeometryBanner,

        resultAbecedniSeznamUlic,

        modulePaths,
        panelWidgets,

        mobileMode,

        mobileMapStreetOpen,
        mobileDetailStreetOpen,

        mobileMapSouborneHesloOpen,
        mobileDetailSouborneHesloOpen,
        mobileShowHideSouborneHesloButton,

        showMobilePopupAlertResponsive,

        isSwipeActive,

        cookiesBannerActive,
        cookiesSettingsModalActive,
        cookiesPermissions,

        activeBasemapId,
        activeWidgetId,

        activeHistoricmapId,

        suggestionsActive,
        appHelpActive,

        streetsAll,

        eventTargetValueHledat,
        resultSuggestions,

        apiBaseUrl,
        apiBaseUrlInt,

        visualizeData,

        loadSources,
        loadTokens,
        loadConfig,
        getModulesFromConfig,
        getSourceUrl,
        addPathToUrl,
    }
})

if ((import.meta as MetaHot).hot) {
    ;(import.meta as MetaHot).hot?.accept(
        acceptHMRUpdate(useMainStore, (import.meta as MetaHot).hot)
    )
}
